import React, { useState } from "react";
import { Box, Flex, IconButton, Slide, useDisclosure } from "@chakra-ui/react";
import { ReactComponent as KeyboardIcon } from "../../assets/icons/icon_Keyboard.svg";
import Keyboard from "react-simple-keyboard";

import "react-simple-keyboard/build/css/index.css";

const KeyBoardDrawer = ({ keyboardRef, onKeyboardChange, onSubmit }) => {
  const { isOpen, onToggle } = useDisclosure();
  const [layoutName, setLayoutName] = useState("caps");

  function handleShift() {
    setLayoutName(layoutName === "shift" ? "default" : "shift");
  }

  function handleCaps() {
    setLayoutName(layoutName === "caps" ? "default" : "caps");
  }

  function onKeyPress(button) {
    if (button === "{enter}") onSubmit();

    if (button === "{shift}") handleShift();

    if (button === "{lock}") handleCaps();
  }
  return (
    <Slide direction="bottom" in={isOpen} style={{ zIndex: 10 }}>
      <Flex background={"rgba(0,0,0,0.4)"} justifyContent={"center"}>
        <Box
          position={"absolute"}
          top={-10}
          left={0}
          right={0}
          pointerEvents={"none"}
        >
          <Box display={"flex"} justifyContent={"center"}>
            <IconButton
              icon={<KeyboardIcon height={"60px"} />}
              onClick={onToggle}
              w={"auto"}
              background={"rgba(0,0,0,0.4)"}
              color={"white"}
              borderBottomRadius={0}
              data-testid={"show-hide-keyboard"}
              pointerEvents={"auto"}
            />
          </Box>
        </Box>

        <Box
          maxW={"1024px"}
          color={"gray.800"}
          fontWeight="bold"
          flex={1}
          data-testid={"keyboard"}
        >
          <Keyboard
            keyboardRef={(r) => (keyboardRef.current = r)}
            inputName={"default"}
            layoutName={layoutName}
            onKeyPress={onKeyPress}
            tabCharOnTab={false}
            layout={{
              default: [
                "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
                "{tab} q w e r t y u i o p [ ] \\",
                "{lock} a s d f g h j k l ; ' {enter}",
                "{shift} z x c v b n m , . / {shift}",
                "{//} {space} {//}",
              ],
              shift: [
                "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
                "{tab} Q W E R T Y U I O P { } |",
                '{lock} A S D F G H J K L : " {enter}',
                "{shift} Z X C V B N M < > ? {shift}",
                "{//} {space} {//}",
              ],
              caps: [
                "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
                "{tab} Q W E R T Y U I O P [ ] \\",
                "{lock} A S D F G H J K L ; ' {enter}",
                "{shift} Z X C V B N M , . / {shift}",
                "{//} {space} {//}",
              ],
            }}
            onChangeAll={onKeyboardChange}
          />
        </Box>
      </Flex>
    </Slide>
  );
};

export default KeyBoardDrawer;
